export default __webpack_public_path__ + "images/8bfcd7faa056ef253b2000c6ff00e5db.jpg";